module.exports = __webpack_public_path__ + "img/qrCode.df46dcad.svg";